import { makeStyles } from "@material-ui/core/styles";
import { SECONDARY_COLOR } from "../../theme";

export const useStyles = makeStyles({
  featuredCard: {
    display: "flex",
    gap: "32px",
    padding: "32px",
    background: "white",
    alignItems: "center",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap: "20px",
      padding: "20px",
    },
  },
  featuredImage: {
    width: "400px",
    height: "250px",
    objectFit: "cover",
    flexShrink: 0,
    "@media (max-width: 768px)": {
      width: "100%",
      height: "250px",
    },
  },
  featuredContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flex: 1,
  },
  featuredTitle: {
    fontSize: "36px",
    fontWeight: 700,
    fontFamily: "Merriweather, serif",
    margin: 0,
    "@media (max-width: 768px)": {
      fontSize: "28px",
    },
  },
  featuredPronunciation: {
    fontSize: "20px",
    opacity: 0.75,
    margin: 0,
  },
  featuredDefinition: {
    fontSize: "18px",
    lineHeight: 1.6,
    margin: 0,
    opacity: 0.9,
  },
  card: {
    padding: "16px",
    background: "white",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  cardImage: {
    width: "100%",
    height: "180px",
    objectFit: "cover",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  cardTitle: {
    fontSize: "20px",
    fontWeight: 700,
    fontFamily: "Merriweather, serif",
    margin: 0,
  },
  cardPronunciation: {
    fontSize: "14px",
    opacity: 0.75,
    margin: 0,
  },
  cardDefinition: {
    fontSize: "15px",
    lineHeight: 1.5,
    margin: 0,
    opacity: 0.9,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    minHeight: "45px",
  },
  learnMoreLink: {
    color: SECONDARY_COLOR,
    textDecoration: "none",
    fontWeight: 600,
    fontSize: "15px",
    marginTop: "auto",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});
